// Indonesian Rupiah formatting: thousands ".", decimals ",", max 2 decimals
export function formatRupiah(value, withSymbol = true) {
  const num = typeof value === "number" ? value : parseNumber(value);
  if (isNaN(num)) return withSymbol ? "Rp 0" : "0";
  const neg = num < 0;
  const abs = Math.abs(num);
  const parts = abs.toFixed(2).split(".");
  let intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  let dec = parts[1];
  let out = dec === "00" ? intPart : `${intPart},${dec}`;
  out = (neg ? "-" : "") + out;
  return withSymbol ? `Rp ${out}` : out;
}

// Convert stored number into an input-display string (id-ID grouping)
export function toInputDisplay(value) {
  if (value === "" || value === null || value === undefined) return "";
  const num = typeof value === "number" ? value : parseNumber(value);
  if (isNaN(num)) return "";
  const parts = Math.abs(num).toFixed(2).split(".");
  let intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const sign = num < 0 ? "-" : "";
  return parts[1] === "00" ? `${sign}${intPart}` : `${sign}${intPart},${parts[1]}`;
}

// Handle raw typing -> format live. Keeps a trailing comma while typing decimals.
export function formatLiveInput(raw) {
  if (raw === null || raw === undefined) return "";
  let s = String(raw);
  const neg = s.trim().startsWith("-");
  // keep only digits and comma
  s = s.replace(/[^0-9,]/g, "");
  const commaIdx = s.indexOf(",");
  let intDigits = commaIdx === -1 ? s : s.slice(0, commaIdx);
  let decDigits = commaIdx === -1 ? null : s.slice(commaIdx + 1).replace(/,/g, "").slice(0, 2);
  intDigits = intDigits.replace(/^0+(?=\d)/, "");
  const grouped = intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  let result = grouped === "" ? (commaIdx !== -1 ? "0" : "") : grouped;
  if (commaIdx !== -1) result = `${result},${decDigits}`;
  return (neg ? "-" : "") + result;
}

// Parse an id-ID formatted string into a JS number
export function parseNumber(str) {
  if (typeof str === "number") return str;
  if (!str) return 0;
  const neg = String(str).trim().startsWith("-");
  let s = String(str).replace(/[^0-9.,]/g, "");
  s = s.replace(/\./g, "").replace(",", ".");
  const n = parseFloat(s);
  const val = isNaN(n) ? 0 : n;
  return neg ? -Math.abs(val) : val;
}

export function formatDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
}
